// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__fjwKc","adminFeatures":"styles_adminFeatures__3fmAs"};